import { SystemFuncArgs } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import MapboxMarker from 'editor/components/map/MapboxMarker';
import MapboxRect from 'editor/components/map/MapboxRect';
import MarkerMarkupSync from 'editor/components/map/MarkerMarkupSync';
import Markup from 'editor/components/Markup';
import { sheetPointToLngLat } from 'editor/utils/map';

export const syncMarkerToMarkupComponents = [
  MapboxMarker,
  Markup,
  MapboxRect, // For now, all markups are rendered on a sheet, which is represented here with a rect.
  MarkerMarkupSync,
];

export function syncMarkerToMarkup(args: SystemFuncArgs<Components>): void {
  const { components } = args;

  const markupComp = components.get(Markup);
  const markerComp = components.get(MapboxMarker);
  const rectComp = components.get(MapboxRect);

  if (!markupComp.mkMarkup) return;

  // get sheet point that marker should be, if it was in sheet space.
  const rect = markupComp.mkMarkup?.getRect();

  const [left, bottom, right] = rect;
  const bottomPadding = 20; // Temp hardcoded value. Should get this off MarkerMarkupSync in the future.

  const x = left + (right - left) / 2;
  const y = bottom - bottomPadding;

  const { width, height } = rectComp;

  // convert
  const { lng, lat } = sheetPointToLngLat(
    rectComp.toImageAlignment(),
    width,
    height,
    { x, y }
  );

  if (markerComp.lng !== lng || markerComp.lat !== lat) {
    markerComp.lng = lng;
    markerComp.lat = lat;
  }
}
